<template>
  <v-container>
    <v-card flat color="transparent">
      <v-card-title class="white--text text-h5 font-weight-bold">Popups auf Webseite & Roody</v-card-title>
      <v-card-subtitle class="white--text pb-4"> Verwalte hier Popups, die auf der Webseite oder in der Roody-App angezeigt werden. </v-card-subtitle>

      <div>
        <div class="section-title">Aktiv & Geplant</div>
        <v-row>
          <v-col cols="12" sm="6" md="4">
            <v-card dark @click="createPopup" class="item-card text-center d-flex flex-column justify-center" min-height="250" hover>
              <v-icon size="60" color="primary">mdi-plus-box-multiple</v-icon>
              <v-card-title class="justify-center pt-3">Neues Popup</v-card-title>
            </v-card>
          </v-col>
          <v-col
            v-if="sortedPopups.active.length > 0 || sortedPopups.upcoming.length > 0"
            v-for="popup in [...sortedPopups.active, ...sortedPopups.upcoming]"
            :key="popup._id"
            cols="12"
            sm="6"
            md="4">
            <v-card dark @click="editPopup(popup._id)" class="item-card d-flex flex-column" min-height="250" hover>
              <div class="status-indicator" :class="popupStatusColor(popup)">
                <v-icon small color="white">{{ popup.status === "aktiv" ? "mdi-broadcast" : "mdi-clock-start" }}</v-icon>
                <span class="ml-1 font-weight-bold">{{ popup.statusText }}</span>
              </div>
              <v-card-title class="pt-4">{{ popup.title }}</v-card-title>
              <v-card-text class="white--text font-weight-light flex-grow-1">
                <div class="d-flex align-center mb-2">
                  <v-icon left small>mdi-map-marker-outline</v-icon>
                  <span>{{ popupLocationText(popup.popupLocation) }}</span>
                </div>
                <div class="d-flex align-center mb-2">
                  <v-icon left small>mdi-account-group-outline</v-icon>
                  <span>{{ popup.employeesOnly ? "Nur Mitarbeiter" : "Alle Benutzer" }}</span>
                </div>
                <div class="d-flex align-center">
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <div v-bind="attrs" v-on="on" class="d-flex align-center">
                        <v-icon left small>mdi-store-outline</v-icon>
                        <span>{{ popup.studios.length }} Studio(s)</span>
                      </div>
                    </template>
                    <span>{{ popupStudioNames(popup).join(", ") }}</span>
                  </v-tooltip>
                </div>
              </v-card-text>
              <v-divider></v-divider>
              <v-card-subtitle class="caption text-center pa-2">
                <v-icon small>mdi-calendar-range</v-icon>
                {{ popupTime(popup) }}
              </v-card-subtitle>
            </v-card>
          </v-col>
        </v-row>
      </div>

      <div v-if="sortedPopups.past.length > 0" class="mt-10">
        <div class="section-title">Archiv</div>
        <v-row>
          <v-col v-for="popup in sortedPopups.past" :key="popup._id" cols="12" sm="6" md="4">
            <v-card dark @click="editPopup(popup._id)" class="item-card d-flex flex-column" min-height="250" hover>
              <div class="status-indicator is-past">
                <v-icon small color="white">mdi-archive-outline</v-icon>
                <span class="ml-1 font-weight-bold">Archiviert</span>
              </div>
              <v-card-title class="pt-4">{{ popup.title }}</v-card-title>
              <v-card-text class="white--text font-weight-light flex-grow-1"> </v-card-text>
              <v-divider></v-divider>
              <v-card-subtitle class="caption text-center pa-2">
                <v-icon small>mdi-calendar-range</v-icon>
                {{ popupTime(popup) }}
              </v-card-subtitle>
            </v-card>
          </v-col>
        </v-row>
      </div>

      <v-alert v-if="popups.length === 0" type="info" class="mt-4" text>
        Es sind noch keine Popups erstellt worden. Klicke auf "Erstellen", um loszulegen.
        <v-btn small class="ml-4" @click="createPopup" color="primary">Erstellen</v-btn>
      </v-alert>
    </v-card>

    <v-dialog v-model="showPopupDialog" max-width="900px" persistent>
      <v-card dark>
        <v-card-title class="text-h5">Popup {{ popup._id ? "bearbeiten" : "erstellen" }}</v-card-title>
        <v-card-text class="pt-4">
          <v-container>
            <v-row>
              <v-col cols="12" md="7">
                <v-text-field v-model="popup.title" label="Titel" placeholder="z.B. 11-Tage-Kampagne" outlined></v-text-field>
                <vue-editor :editorToolbar="customToolbar" v-model="popup.text"></vue-editor>
                <v-select
                  class="mt-6"
                  v-model="popup.studios"
                  :items="studios"
                  item-text="name"
                  item-value="_id"
                  label="Studios"
                  multiple
                  chips
                  outlined
                  attach></v-select>
              </v-col>
              <v-col cols="12" md="5">
                <slim-cropper :key="popup.image" style="width: 100%" :options="slimOptionsExercise">
                  <img v-if="popup.image" :src="linkPreview + '/img/' + popup.image" alt="" />
                  <input type="file" accept="image/*" />
                </slim-cropper>
                <v-card-subtitle class="text-center">Format: 16:9 (1920x1080)</v-card-subtitle>
                <v-divider class="my-4"></v-divider>
                <v-menu
                  ref="showAfterMenu"
                  v-model="showAfterMenu"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  min-width="auto">
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="formattedShowAfter"
                      label="Anzeigen ab"
                      prepend-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                      outlined
                      clearable
                      @click:clear="popup.showAfter = null"></v-text-field>
                  </template>
                  <v-date-picker v-model="popup.showAfter" @input="showAfterMenu = false" locale="de" no-title></v-date-picker>
                </v-menu>
                <v-menu
                  ref="hideAfterMenu"
                  v-model="hideAfterMenu"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  min-width="auto">
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="formattedHideAfter"
                      label="Ausblenden ab"
                      prepend-icon="mdi-calendar-off"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                      outlined
                      clearable
                      @click:clear="popup.hideAfter = null"></v-text-field>
                  </template>
                  <v-date-picker v-model="popup.hideAfter" @input="hideAfterMenu = false" locale="de" no-title></v-date-picker>
                </v-menu>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <v-divider class="my-3"></v-divider>
                <strong>Anzeige-Optionen</strong>
              </v-col>
              <v-col cols="12" md="4">
                <v-radio-group v-model="popup.popupLocation" row>
                  <v-radio label="Nur Webseite" value="website"></v-radio>
                  <v-radio label="Nur Roody" value="roody"></v-radio>
                  <v-radio label="Beide" value="both"></v-radio>
                </v-radio-group>
              </v-col>
              <v-col cols="12" md="4">
                <v-switch
                  v-if="['website', 'both'].includes(popup.popupLocation)"
                  v-model="popup.visibility.everywhere"
                  label="Auf Startseite (Web)"></v-switch>
              </v-col>
              <v-col cols="12" md="4">
                <v-switch v-if="popup.popupLocation === 'roody'" v-model="popup.employeesOnly" label="Nur für Mitarbeiter"></v-switch>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <v-divider class="my-3"></v-divider>
                <strong>Button & Aktions-Link (Optional)</strong>
              </v-col>

              <v-col cols="12" md="4">
                <v-text-field
                  v-model="popup.linkText"
                  label="Button Text"
                  placeholder="z.B. Jetzt buchen"
                  outlined
                  hide-details="auto"></v-text-field>
              </v-col>

              <v-col cols="12" md="3" class="d-flex align-center">
                <v-switch v-model="isExternalLink" label="Externer Link" class="mt-0" hide-details></v-switch>
              </v-col>

              <v-col cols="12" md="5">
                <v-text-field
                  v-if="!isExternalLink"
                  v-model="popup.link"
                  label="Interner Pfad"
                  prefix="app.wellcomefit.ch"
                  placeholder="/referral"
                  outlined
                  hide-details="auto"></v-text-field>

                <v-text-field
                  v-else
                  v-model="popup.link"
                  label="Externe URL"
                  placeholder="https://www.google.com"
                  outlined
                  hide-details="auto"></v-text-field>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="cancel">Abbrechen</v-btn>
          <v-btn color="primary" @click="save" :disabled="!formValidated">Speichern</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
// Der Script-Teil bleibt größtenteils gleich, mit Anpassungen für die Sortierung.
import { VueEditor } from "vue2-editor"
import Slim from "../../../plugins/slimImage/slim/slim.vue"
import api from "@/api"
import moment from "moment"

export default {
  name: "popups",
  components: { VueEditor, "slim-cropper": Slim },
  data() {
    return {
      isExternalLink: false, // <-- NEU
      studios: [],
      popup: {},
      showPopupDialog: false,
      popups: [],
      customToolbar: [
        [{ header: [false, 1, 2, 3, 4, 5, 6] }],
        ["bold", "italic", "underline", "strike"],
        [{ list: "ordered" }, { list: "bullet" }],
        [{ color: [] }, { background: [] }],
        ["link", "clean"],
      ],
      slimOptionsExercise: {
        ratio: "16:9",
        initialImage: "/img/einmalig/imageUploadPlaceholder.jpg",
        buttonCancelLabel: "Abbrechen",
        buttonConfirmLabel: "Bestätigen",
        label: "Bild hochladen",
        labelLoading: "Bild wird hochgeladen",
        statusUploadSuccess: "gespeichert",
        service: this.uploadPicture,
        serviceFormat: "file",
        instantEdit: true,
        push: true,
      },
      showAfterMenu: false,
      hideAfterMenu: false,
    }
  },
  async created() {
    this.fetchPopups()
    let studios = await api.fetchStudios()
    this.studios = studios.filter((e) => e.code !== "alibey" && e.code !== "ot")
    this.resetPopup()
  },
  computed: {
    linkPreview() {
      return ""
    },
    // NEU: Sortiert die Popups in Kategorien
    sortedPopups() {
      const categories = { active: [], upcoming: [], past: [] }
      if (!this.popups) return categories

      this.popups.forEach((popup) => {
        const { status } = this.getPopupStatus(popup)
        switch (status) {
          case "aktiv":
            categories.active.push(popup)
            break
          case "geplant":
            categories.upcoming.push(popup)
            break
          default:
            categories.past.push(popup)
        }
      })
      return categories
    },
    formattedShowAfter() {
      return this.popup.showAfter ? moment(this.popup.showAfter).format("DD.MM.YYYY") : ""
    },
    formattedHideAfter() {
      return this.popup.hideAfter ? moment(this.popup.hideAfter).format("DD.MM.YYYY") : ""
    },
    formValidated() {
      if (!this.popup.title) return false
      return this.popup.title.length > 3 && this.popup.studios.length > 0 && (this.popup.image || this.popup.text.length > 3)
    },
  },
  methods: {
    getPopupStatus(popup) {
      const now = moment()
      if (popup.hideAfter && moment(popup.hideAfter).isBefore(now, "day")) {
        return { status: "inaktiv", text: "Inaktiv" }
      } else if (popup.showAfter && moment(popup.showAfter).isAfter(now, "day")) {
        const diff = moment(popup.showAfter).diff(now, "days") + 1
        return { status: "geplant", text: `Startet in ${diff} Tag${diff > 1 ? "en" : ""}` }
      } else {
        return { status: "aktiv", text: "Aktiv" }
      }
    },
    popupStudioNames(popup) {
      return popup.studios.map((studioId) => {
        const studio = this.studios.find((s) => s._id === studioId)
        return studio ? studio.name : "Unbekannt"
      })
    },
    popupTime(popup) {
      const { showAfter, hideAfter } = popup
      const format = (date) => moment(date).format("DD.MM.YYYY")

      if (showAfter && hideAfter) return `Von ${format(showAfter)} bis ${format(hideAfter)}`
      if (showAfter && !hideAfter) return `Ab ${format(showAfter)}`
      if (!showAfter && hideAfter) return `Bis ${format(hideAfter)}`
      return "Dauerhaft aktiv"
    },
    popupLocationText(location) {
      if (location === "roody") return "Nur Roody"
      if (location === "website") return "Nur Webseite"
      return "Webseite und Roody"
    },
    popupStatusColor(popup) {
      const { status } = this.getPopupStatus(popup)
      if (status === "aktiv") return "is-visible"
      if (status === "geplant") return "is-upcoming"
      return "is-past"
    },
    async createPopup() {
      this.resetPopup()
      this.showPopupDialog = true
    },
    async editPopup(id) {
      this.resetPopup()
      try {
        let popup = await api.PopupService.get(id)
        if (popup && popup._id) {
          if (popup.showAfter) popup.showAfter = moment(popup.showAfter).format("YYYY-MM-DD")
          if (popup.hideAfter) popup.hideAfter = moment(popup.hideAfter).format("YYYY-MM-DD")

          // <-- NEU: Prüfen, ob es ein externer Link ist
          if (popup.link && popup.link.startsWith("http")) {
            this.isExternalLink = true
          } else {
            this.isExternalLink = false
          }

          this.popup = popup
          this.showPopupDialog = true
        } else {
          throw Error("Fehler beim Laden")
        }
      } catch (e) {
        this.$toast.error("Fehler beim Laden des Popups")
      }
    },
    cancel() {
      this.showPopupDialog = false
      this.resetPopup()
    },
    async save() {
      const payload = JSON.parse(JSON.stringify(this.popup))
      if (payload.studios.some((s) => typeof s === "object")) {
        payload.studios = payload.studios.map((s) => s._id)
      }

      // <-- NEU: Formatierung des Links sicherstellen
      if (payload.link) {
        if (!this.isExternalLink && !payload.link.startsWith("/")) {
          payload.link = "/" + payload.link
        }
      } else {
        payload.linkText = "" // Bereinigen, falls Link leer ist
      }

      try {
        if (payload._id) {
          await api.PopupService.update(payload._id, payload)
        } else {
          await api.PopupService.create(payload)
        }
        this.$toast.success("Popup erfolgreich gespeichert")
        this.cancel()
        this.fetchPopups()
      } catch (e) {
        this.$toast.error("Fehler beim Speichern")
      }
    },
    resetPopup() {
      this.isExternalLink = false // <-- NEU
      this.popup = {
        popupLocation: "roody",
        hideAfter: null,
        showAfter: null,
        visibility: { everywhere: false, paths: [] },
        title: "",
        text: "",
        image: "",
        employeesOnly: false,
        studios: [],
        link: "", // <-- NEU
        linkText: "", // <-- NEU
      }
    },
    async fetchPopups() {
      try {
        const popups = await api.PopupService.getAll()
        this.popups = popups.map((p) => ({
          ...p,
          status: this.getPopupStatus(p).status,
          statusText: this.getPopupStatus(p).text,
        }))
      } catch (e) {
        this.$toast.error("Fehler beim Laden der Popups")
      }
    },
    uploadPicture(formdata, progress, success, failure) {
      const formData = new FormData()
      formData.append("file", formdata[0])
      api
        .uploadImage({ art: "popup", formData })
        .then((data) => {
          if (data.status) {
            this.popup.image = data.name
            success(data)
          }
        })
        .catch((error) => failure(error))
    },
  },
}
</script>

<style scoped>
.item-card {
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  border-radius: 12px !important;
  background: linear-gradient(145deg, #2a2a2a, #1e1e1e);
  box-shadow: 5px 5px 15px #1c1c1c, -5px -5px 15px #2e2e2e;
  border: 2px solid transparent;
  position: relative;
  height: 100%;
}

.item-card:hover {
  transform: translateY(-5px);
  border-color: var(--v-primary-base);
}

.status-indicator {
  position: absolute;
  top: 10px;
  right: 10px;
  padding: 4px 10px;
  border-radius: 12px;
  font-size: 0.8rem;
  color: white;
  display: flex;
  align-items: center;
}
.status-indicator.is-visible {
  background-color: #4caf50;
}
.status-indicator.is-upcoming {
  background-color: #ff9800;
}
.status-indicator.is-past {
  background-color: #616161;
}

.section-title {
  font-size: 1.5rem;
  font-weight: bold;
  color: white;
  margin-bottom: 16px;
  padding-left: 8px;
  border-left: 4px solid var(--v-primary-base);
}
</style>
